import { Layout } from '@components/Layout';
import { Partner } from '@features/Partner';
import { usePageStateHandler } from '@hooks/usePageStateHandler';
import { usePartnerConnectors } from '@hooks/usePartnerConnectors';
import { withProfiler } from '@services/sentry/withProfiler';

const PAGE_TITLE = 'Set up your appointment';

const PartnerSetUpUnwrapped = () => {
  const { connectors, loading } = usePartnerConnectors();

  const { isLoading } = usePageStateHandler({
    loading,
    hasData: true,
    error: false,
  });

  if (isLoading) {
    return null;
  }

  return (
    <Layout title={PAGE_TITLE}>
      <Partner connectors={connectors} />
    </Layout>
  );
};

const PartnerSetUp = withProfiler(PartnerSetUpUnwrapped);
export { PartnerSetUp };
